export default "__VITE_ASSET__DEwnQRPk__"